import { routes } from '../../../constants/routesAndApisConstants';
import { getUrlFor } from '../../routing/utils/url';

export type GA4PageViewUserDataType = {
  upcoming_trip?: number;
  no_of_orders?: number;
  cancelled_orders?: number;
  archived_orders?: number;
};

export type GA4PageViewParamsType = {
  responsive_url: string;
  page_type: string;
  page_type_detailed: string;
  page_location?: string;
  already_bought_products?: string;
  booking_flow?: string;
  brand?: string;
  check_in_status?: string;
  days_to_departure?: number;
  dbf?: boolean;
  destination_country_code?: string;
  end_date?: string;
  entry_type?: string;
  entry_type_domain?: string;
  flow?: string;
  hours_to_departure?: number;
  minutes_to_departure?: number;
  no_of_adults?: number;
  no_of_children?: number;
  no_of_days?: number;
  no_of_infants?: number;
  obf_order_id?: string;
  origin_country_code?: string;
  pax?: number;
  site_country?: string;
  site_name?: string;
  start_date?: string;
  trip_event?: string;
  trip_type?: string;
  validating_carrier?: string;
  userData?: GA4PageViewUserDataType;
};

export const buildResponsivePageViewEvent = ({
  responsive_url,
  page_type,
  page_type_detailed,
  page_location,
  already_bought_products,
  booking_flow,
  brand,
  check_in_status,
  days_to_departure,
  dbf,
  destination_country_code,
  end_date,
  entry_type,
  entry_type_domain,
  flow,
  hours_to_departure,
  minutes_to_departure,
  no_of_adults,
  no_of_children,
  no_of_days,
  no_of_infants,
  obf_order_id,
  origin_country_code,
  pax,
  site_country,
  site_name,
  start_date,
  trip_event,
  trip_type,
  validating_carrier,
  userData,
}: GA4PageViewParamsType) => {
  const page_referrer = sessionStorage.getItem('documentReferrer') || document.referrer;
  sessionStorage.setItem('documentReferrer', window.location.href);

  const scenarios =
    window?.spa_variables && 'scenarios' in window.spa_variables
      ? window.spa_variables.scenarios
      : [];

  return {
    event: 'responsive_pageview',
    pageData: {
      already_bought_products,
      booking_flow,
      brand,
      check_in_status,
      days_to_departure,
      dbf,
      destination_country_code,
      end_date,
      entry_type,
      entry_type_domain,
      flow,
      hours_to_departure,
      minutes_to_departure,
      no_of_adults,
      no_of_children,
      no_of_days,
      no_of_infants,
      obf_order_id,
      origin_country_code,
      page_location: page_location ?? window.location.href,
      page_referrer,
      page_title: document.title,
      page_type,
      page_type_detailed,
      pax,
      privacy_policy_url: getUrlFor(routes.PRIVACY_POLICY).href,
      responsive_url,
      scenarios,
      site_country,
      site_name,
      start_date,
      trip_event,
      trip_type,
      validating_carrier,
    },
    userData,
  };
};
